import React, { useEffect, useMemo, useState } from "react";
import api from "../../../api";
import "./InventoryPanel.css";
import {
  POKEBALL_ITEM_ID,
  GREATBALL_ITEM_ID,
  ULTRABALL_ITEM_ID,
  LONGBALL_ITEM_ID,
  RANGEBALL_ITEM_ID,
  MUDBALL_ITEM_ID,
  RUBYBALL_ITEM_ID,
  SAPPHIREBALL_ITEM_ID,
  EMERALDBALL_ITEM_ID,
  GOLDENBALL_ITEM_ID,
  DIAMONDBALL_ITEM_ID,
  SHADOWBALL_ITEM_ID,
  MASTERBALL_ITEM_ID,
  LURE_ITEM_ID,
  SUPER_LURE_ITEM_ID,
  ULTRA_LURE_ITEM_ID,
  DROP_POTION_ID,
  MINING_POTION,
  SHINY_POTION_ID,
  SCENT_GENGAR_ID,
  MINERAL_POTION_ID,
  pokeballImg,
  rubyGummyImg,
  sapphireGummyImg,
  emeraldGummyImg,
  goldenGummyImg,
  diamondGummyImg,
  greatballImg,
  ultraballImg,
  rangeballImg,
  longballImg,
  lureImg,
  superLureImg,
  ultraLureImg,
  mineLureImg,
  dropLureImg,
  // mineralPotionImg,
  // shinyPotionImg,
  scentofGengarImg,
  mudballImg,
  rubyballImg,
  sapphireballImg,
  emeraldballImg,
  goldenballImg,
  diamondballImg,
  shadowballImg,
  masterballImg,
  rawstberryImg,
  sitrusberryImg,
  razzberryImg,
  magostberryImg,
  aspearberryImg,
  figyBerryImg,
  lumberryImg,
  aguavberryImg,
  oranberryimg,
  pechaberryimg,
  wikiberryimg,
  heartberryimg,
} from "../../../constants/items";

import sapphireImg from "../../../assets/images/items/sapphire.png";
import rubyImg     from "../../../assets/images/items/ruby.png";
import emeraldImg  from "../../../assets/images/items/emerald.png";
import goldImg     from "../../../assets/images/items/gold.png";
import diamondImg  from "../../../assets/images/items/diamond.png";
import rockImg     from "../../../assets/images/items/rock.png";

// Evolution stone image paths (using public folder)
const EVOLUTION_STONE_PATHS = {
  fire_stone: "/items/firestone.png",
  water_stone: "/items/waterstone.png",
  thunder_stone: "/items/thunderstone.png",
  leaf_stone: "/items/leafstone.png",
  moon_stone: "/items/moonstone.png",
  dawn_stone: "/items/dawnstone.png",
  metal_coat: "/items/metalcoat.png",
  kings_rock: "/items/kingsrock.png"
};

// IDs of gummies to include in items panel
const GUMMY_IDS = [6, 7, 8, 9, 10];

export default function InventoryPanel({
  inventory = [],
  gems = {},
  selectedAction,
  setSelectedAction,
  handleLureClick,
  resetRocks,
  spawnText,
  playerPos,
  onMineralPotionUse,
  onClose,
  activeLure = null, // Add activeLure prop to check which lures are active
  expLureHits = 0, // Mining XP Lure hits
  dropLureHits = 0, // Drop Rate Lure hits
  activeGummy = null, // Active gummy type (ruby, sapphire, emerald, golden, diamond)
}) {

  const [viewport, setViewport] = useState({ width: window.innerWidth, height: window.innerHeight });

  useEffect(() => {
    const onResize = () => setViewport({ width: window.innerWidth, height: window.innerHeight });
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const layout = useMemo(() => {
    const isMobile = viewport.width <= 768;
    const panelWidth = isMobile
      ? Math.max(160, viewport.width - 32)
      : Math.max(240, Math.min(viewport.width - 64, 760));

    const panelMaxHeight = Math.max(320, Math.min(Math.floor(viewport.height * 0.9), 780));

    const gap = isMobile ? 8 : 8;
    const cols = Math.max(4, Math.min(isMobile ? 6 : 6, Math.floor((panelWidth - 24) / (isMobile ? 72 : 72))));
    const tile = Math.max(60, Math.min(isMobile ? 70 : 70, Math.floor((panelWidth - 24 - (cols - 1) * gap) / cols)));

    const headerBlock = 32;
    const sectionHeader = 26;
    const itemsMaxHeight = Math.max(200, Math.floor(panelMaxHeight - headerBlock - sectionHeader - 140));
    const gemsMaxHeight = Math.max(140, Math.floor(panelMaxHeight - headerBlock - sectionHeader - itemsMaxHeight - 24));

    const gridJustify = panelWidth >= 420 ? "center" : "start";

    return {
      panelWidth,
      panelMaxHeight,
      cols,
      gap,
      tile,
      itemsMaxHeight,
      gemsMaxHeight,
      gridJustify,
    };
  }, [viewport.width, viewport.height]);

  // State for confirmation modal
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [confirmationItem, setConfirmationItem] = useState(null);
  const [confirmationItemName, setConfirmationItemName] = useState("");
  
  // Show confirmation dialog for lures and potions
  const showItemConfirmation = (itemId, itemName) => {
    setConfirmationItem(itemId);
    setConfirmationItemName(itemName);
    setShowConfirmation(true);
  };

  // Handle confirmation dialog actions
  const handleConfirm = () => {
    if (!confirmationItem) return;
    
    if (confirmationItem === MINERAL_POTION_ID) {
      handleMineralPotionUse(confirmationItem);
    } else if ([LURE_ITEM_ID, SUPER_LURE_ITEM_ID, ULTRA_LURE_ITEM_ID, MINING_POTION, SHINY_POTION_ID, DROP_POTION_ID, SCENT_GENGAR_ID, 6, 7, 8, 9, 10].includes(confirmationItem) && handleLureClick) {
      handleLureClick(confirmationItem);
    }
    
    // Reset confirmation state
    setShowConfirmation(false);
    setConfirmationItem(null);
    setConfirmationItemName('');
  };

  const handleCancel = () => {
    setShowConfirmation(false);
    setConfirmationItem(null);
    setConfirmationItemName('');
  };

  const handleMineralPotionUse = async (itemId) => {
    try {
      const response = await api.post(
        "/v1/use_item",
        { item_id: itemId },
        { withCredentials: true }
      );

      if (response.data.success) {
        // Use spawnText instead of alert if available
        if (spawnText && playerPos) {
          spawnText("Mineral Potion activated! All rocks will be minerals for 2 minutes.", playerPos.x, playerPos.y - 32, "#7fffd4", "💎");
        }

        // Store the expiration time if provided
        if (response.data.expiration && onMineralPotionUse) {
          onMineralPotionUse(response.data.expiration);
        }

        setSelectedAction(null);
        if (resetRocks) {
          resetRocks();
        }
      } else {
        // Show error message as spawn text if available, otherwise fall back to alert
        if (spawnText && playerPos) {
          spawnText(response.data.message || "Failed to use Mineral Potion", playerPos.x, playerPos.y - 32, "#ff6b6b");
        } else {
          alert(response.data.message || "Failed to use Mineral Potion");
        }
      }
    } catch (error) {
      console.error("Error using Mineral Potion:", error);
    }
  };


  // Determine item rarity for visual styling
  const getItemRarity = (itemId) => {
    if ([MASTERBALL_ITEM_ID, DIAMONDBALL_ITEM_ID, 10].includes(itemId)) {
      return 'legendary';
    }
    if ([SHADOWBALL_ITEM_ID, GOLDENBALL_ITEM_ID, 9, ULTRA_LURE_ITEM_ID].includes(itemId)) {
      return 'epic';
    }
    if ([EMERALDBALL_ITEM_ID, SAPPHIREBALL_ITEM_ID, RUBYBALL_ITEM_ID, 6, 7, 8, SUPER_LURE_ITEM_ID].includes(itemId)) {
      return 'rare';
    }
    return 'common';
  };

  // Render a Poké-ball, potion, lure, or gummy item
  const renderItem = item => {
    const isBall = [
      POKEBALL_ITEM_ID,
      GREATBALL_ITEM_ID,
      ULTRABALL_ITEM_ID,
      LONGBALL_ITEM_ID,
      RANGEBALL_ITEM_ID,
      MUDBALL_ITEM_ID,
      RUBYBALL_ITEM_ID,
      SAPPHIREBALL_ITEM_ID,
      EMERALDBALL_ITEM_ID,
      GOLDENBALL_ITEM_ID,
      DIAMONDBALL_ITEM_ID,
      SHADOWBALL_ITEM_ID,
      MASTERBALL_ITEM_ID,
    ].includes(item.item);

    const isBerry = item.item === 199 || item.item === 200 || item.item === 201 || item.item === 202 || item.item === 203|| item.item === 204|| item.item === 205|| item.item === 206|| item.item === 207|| item.item === 208|| item.item === 209|| item.item === 210;

    const isMulch = item.item === 141 || item.item === 142;

    const isSel =
      (isBall &&
        selectedAction?.type === "ball" &&
        selectedAction.payload.item === item.item) ||
      (isBerry &&
        selectedAction?.type === "berry" &&
        selectedAction.payload.item === item.item) ||
      (isMulch &&
        selectedAction?.type === "mulch" &&
        selectedAction.payload.item === item.item) ||
      (!isBall && !isBerry &&
        selectedAction?.type === "item" &&
        selectedAction.payload === item.item);

    let img, alt;
    switch (item.item) {
      case POKEBALL_ITEM_ID:       img = pokeballImg;      alt = "Pokéball";         break;
      case GREATBALL_ITEM_ID:      img = greatballImg;     alt = "Great Ball";      break;
      case ULTRABALL_ITEM_ID:      img = ultraballImg;     alt = "Ultra Ball";      break;
      case LONGBALL_ITEM_ID:       img = longballImg;      alt = "Long Ball";       break;
      case MUDBALL_ITEM_ID:        img = mudballImg;       alt = "Mud Ball";        break;
      case RUBYBALL_ITEM_ID:       img = rubyballImg;      alt = "Ruby Ball";       break;
      case SAPPHIREBALL_ITEM_ID:   img = sapphireballImg;  alt = "Sapphire Ball";   break;
      case EMERALDBALL_ITEM_ID:    img = emeraldballImg;   alt = "Emerald Ball";    break;
      case GOLDENBALL_ITEM_ID:     img = goldenballImg;    alt = "Golden Ball";     break;
      case DIAMONDBALL_ITEM_ID:    img = diamondballImg;   alt = "Diamond Ball";    break;
      case SHADOWBALL_ITEM_ID:    img = shadowballImg;   alt = "Shadow Ball";    break;
      case MASTERBALL_ITEM_ID:    img = masterballImg;   alt = "Master Ball";    break;
      case RANGEBALL_ITEM_ID:      img = rangeballImg;     alt = "Range Ball";      break;
      case LURE_ITEM_ID:           img = lureImg;          alt = "Lure";            break;
      case SUPER_LURE_ITEM_ID:     img = superLureImg;     alt = "Super Lure";      break;
      case ULTRA_LURE_ITEM_ID:     img = ultraLureImg;     alt = "Ultra Lure";      break;
      case MINING_POTION:          img = mineLureImg;      alt = "Mining Potion";   break;
      case DROP_POTION_ID:         img = dropLureImg;      alt = "Drop Potion";     break;
      // case MINERAL_POTION_ID:      img = mineralPotionImg; alt = "Mineral Potion";  break;
      // case SHINY_POTION_ID:        img = shinyPotionImg;   alt = "Shiny Potion";    break;
      case SCENT_GENGAR_ID:        img = scentofGengarImg;   alt = "Scent of Gengar";    break;
      case 6:                      img = rubyGummyImg;     alt = "Ruby Gummy";      break;
      case 7:                      img = sapphireGummyImg; alt = "Sapphire Gummy";  break;
      case 8:                      img = emeraldGummyImg;  alt = "Emerald Gummy";   break;
      case 9:                      img = goldenGummyImg;   alt = "Golden Gummy";    break;
      case 10:                     img = diamondGummyImg;  alt = "Diamond Gummy";   break;
      case 199:                    img = rawstberryImg;    alt = "Rawstberry";    break;
      case 200:                    img = sitrusberryImg;    alt = "Sitrusberry";    break;
      case 201:                    img = aspearberryImg;    alt = "Aspearberry";    break;
      case 202:                    img = magostberryImg;    alt = "Magostberry";    break;
      case 203:                    img = razzberryImg;    alt = "Razzberry";    break;
      case 204:                    img= aguavberryImg; alt = "Aguav Berry"; break;
      case 205:                    img= figyBerryImg; alt = "Figy Berry"; break;
      case 206:                    img= lumberryImg; alt = "Lum Berry"; break;
      case 207:                    img= oranberryimg; alt = "Oran Berry"; break;
      case 208:                    img= pechaberryimg; alt = "Pecha Berry"; break;
      case 209:                    img= wikiberryimg; alt = "Wiki Berry"; break;
      case 210:                    img= heartberryimg; alt = "Heart Berry"; break;
      case 141:                    img = "/items/mulchofgains.png";    alt = "Mulch of Gains";    break;
      case 142:                    img = "/items/mulchoftime.png";    alt = "Mulch of Time";    break;
      default:                     img = pokeballImg;      alt = "Item";
    }

    // Check if any lure is active and this is a different lure
    const isLure = [LURE_ITEM_ID, SUPER_LURE_ITEM_ID, ULTRA_LURE_ITEM_ID].includes(item.item);
    const isOtherLureActive = 
      isLure && 
      activeLure && 
      !((item.item === LURE_ITEM_ID && activeLure === "lure") ||
        (item.item === SUPER_LURE_ITEM_ID && activeLure === "super_lure") ||
        (item.item === ULTRA_LURE_ITEM_ID && activeLure === "ultra_lure"));
    
    // Check if mining or drop potion is already active
    const isMiningPotion = item.item === MINING_POTION;
    const isDropPotion = item.item === DROP_POTION_ID;
    const isMiningPotionActive = isMiningPotion && expLureHits > 0;
    const isDropPotionActive = isDropPotion && dropLureHits > 0;
    
    // Check if this is a gummy and if a different gummy is active
    const isGummy = GUMMY_IDS.includes(item.item);
    const gummyTypeMap = {
      6: 'ruby',
      7: 'sapphire',
      8: 'emerald',
      9: 'golden',
      10: 'diamond'
    };
    const thisGummyType = gummyTypeMap[item.item];
    const isOtherGummyActive = isGummy && activeGummy && activeGummy !== thisGummyType;
    
    // Disable other lures when one is active, or disable potions when already active, or disable other gummies
    const isDisabled = isOtherLureActive || isMiningPotionActive || isDropPotionActive || isOtherGummyActive;
    
    const onClick = (e) => {
      // Stop event propagation to prevent togglePouch from being called
      e.stopPropagation();
      
      // Don't do anything if item is disabled
      if (isDisabled) return;
      
      if (isBall) {
        localStorage.setItem("selectedBall", item.item.toString());
        setSelectedAction({ type: "ball", payload: item });
      } else if (isBerry) {
        // Berry - treat like pokeball, no confirmation
        localStorage.setItem("selectedBerry", item.item.toString());
        setSelectedAction({ type: "berry", payload: item });
      } else if (isMulch) {
        localStorage.setItem("selectedMulch", item.item.toString());
        setSelectedAction({ type: "mulch", payload: item });
      } else if (item.item === MINERAL_POTION_ID || 
                [LURE_ITEM_ID, SUPER_LURE_ITEM_ID, ULTRA_LURE_ITEM_ID, MINING_POTION, SHINY_POTION_ID, DROP_POTION_ID, 6, 7, 8, 9, 10, SCENT_GENGAR_ID].includes(item.item)) {
        // Show confirmation for potions and lures
        showItemConfirmation(item.item, alt);
      } else {
        localStorage.setItem("selectedRock", item.item.toString());
        setSelectedAction({ type: "item", payload: item.item });
      }
    };

    const rarity = getItemRarity(item.item);
    const rarityClass = `rarity-${rarity}`;

    return (
      <div
        key={item.item}
        onClick={onClick}
        className={`item-slot ${rarityClass} ${isSel ? 'selected' : ''} ${isDisabled ? 'disabled' : ''}`}
        style={{
          width: layout.tile,
          height: layout.tile,
        }}
      >
        <div className="item-image-container">
          <img
            src={img}
            alt={alt}
            className="item-image"
          />
        </div>
        <div 
          className="item-quantity"
          style={{
            fontSize: Math.max(11, Math.min(13, Math.floor(layout.tile * 0.18)))
          }}
        >
          {item.amount}
        </div>
      </div>
    );
  };

  // Determine gem rarity for visual styling
  const getGemRarity = (name) => {
    if (name === 'diamond') return 'legendary';
    if (name === 'gold') return 'epic';
    if (['ruby', 'sapphire', 'emerald'].includes(name)) return 'rare';
    return 'common';
  };

  // Render a gem (rock, sapphire, etc.) - separate gem currency
  const renderGem = ([name, amount]) => {
    // Make sure we use the correct image for each mineral type
    let icon;
    
    // Check if it's an evolution stone
    if (EVOLUTION_STONE_PATHS[name]) {
      // Use the public path for evolution stones
      icon = EVOLUTION_STONE_PATHS[name];
    } else {
      // Use imported images for basic minerals
      switch (name) {
        case "ruby": icon = rubyImg; break;
        case "sapphire": icon = sapphireImg; break;
        case "emerald": icon = emeraldImg; break;
        case "gold": icon = goldImg; break;
        case "diamond": icon = diamondImg; break;
        case "rock": icon = rockImg; break;
        // For any other items, use rock image as fallback
        default: icon = rockImg;
      }
    }
    
    const isSel = selectedAction?.type === "item" && selectedAction.payload === name;

    const onClick = (e) => {
      // Stop event propagation to prevent togglePouch from being called
      e.stopPropagation();
      setSelectedAction({ type: "item", payload: name });
    };

    const rarity = getGemRarity(name);
    const rarityClass = `rarity-${rarity}`;

    return (
      <div
        key={name}
        onClick={onClick}
        className={`item-slot ${rarityClass} ${isSel ? 'selected' : ''}`}
        style={{
          width: layout.tile,
          height: layout.tile,
        }}
      >
        <div className="item-image-container">
          <img
            src={icon}
            alt={name}
            className="item-image"
          />
        </div>
        <div 
          className="item-quantity"
          style={{
            fontSize: Math.max(11, Math.min(13, Math.floor(layout.tile * 0.18)))
          }}
        >
          {amount}
        </div>
      </div>
    );
  };

  // Split inventory into categories
  const pokeballs = inventory.filter(i =>
    [POKEBALL_ITEM_ID, GREATBALL_ITEM_ID, ULTRABALL_ITEM_ID, LONGBALL_ITEM_ID, RANGEBALL_ITEM_ID, MUDBALL_ITEM_ID, RUBYBALL_ITEM_ID, SAPPHIREBALL_ITEM_ID, EMERALDBALL_ITEM_ID, GOLDENBALL_ITEM_ID, DIAMONDBALL_ITEM_ID, SHADOWBALL_ITEM_ID, MASTERBALL_ITEM_ID]
      .includes(i.item)
  );
  const lures = inventory.filter(i =>
    [LURE_ITEM_ID, SUPER_LURE_ITEM_ID, ULTRA_LURE_ITEM_ID].includes(i.item)
  );
  const potions = inventory.filter(i =>
    [MINING_POTION, DROP_POTION_ID, MINERAL_POTION_ID,SHINY_POTION_ID,SCENT_GENGAR_ID ].includes(i.item)
  );
  const gummies = inventory.filter(i => GUMMY_IDS.includes(i.item));
  const berries = inventory.filter(i =>
    [199,200,201,202,203,204,205,206,207,208,209,210 ].includes(i.item)
  );
  const mulches = inventory.filter(i =>
    [141, 142].includes(i.item)
  );
  const orderedItems = [...pokeballs, ...lures, ...potions, ...gummies, ...mulches, ...berries];

  return (
    <>
      {/* Confirmation Modal */}
      {showConfirmation && (
        <>
          {/* Semi-transparent overlay - only close modal when clicking it, not the entire inventory */}
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: 2000,
              pointerEvents: "all"
            }}
            onClick={(e) => {
              e.stopPropagation(); // Prevent closing the inventory
              handleCancel();
            }}
          />
          <div
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "220px",
              background: "linear-gradient(145deg, #2d3748, #1a202c)",
              borderRadius: "8px",
              padding: "16px",
              boxShadow: "0 4px 20px rgba(0, 0, 0, 0.5)",
              border: "1px solid rgba(255, 255, 255, 0.1)",
              zIndex: 2001,
              color: "#fff",
              textAlign: "center"
            }}
          >
          <h3 style={{ margin: "0 0 10px 0", fontSize: "15px", color: "#ffd700" }}>
            Confirm Use
          </h3>
          <p style={{ margin: "0 0 12px 0", color: "#cbd5e0", fontSize: "13px" }}>
            Are you sure you want to use {confirmationItemName}?
          </p>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "10px",
            }}
          >
            <button
              onClick={(e) => {
                e.stopPropagation(); // Prevent closing the inventory
                handleCancel();
              }}
              style={{
                background: "linear-gradient(to bottom, #4a5568, #2d3748)",
                color: "#fff",
                border: "1px solid #1a202c",
                padding: "6px 12px",
                borderRadius: "4px",
                cursor: "pointer",
                fontSize: "12px",
                fontWeight: "500",
                boxShadow: "0 1px 3px rgba(0, 0, 0, 0.3)",
                transition: "all 0.2s ease",
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.background = "linear-gradient(to bottom, #4a5568, #3a4556)";
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.background = "linear-gradient(to bottom, #4a5568, #2d3748)";
              }}
            >
              Cancel
            </button>
            <button
              onClick={(e) => {
                e.stopPropagation(); // Prevent closing the inventory
                handleConfirm();
              }}
              style={{
                background: "linear-gradient(135deg, #667eea, #764ba2)",
                color: "#fff",
                border: "1px solid #4c366b",
                padding: "6px 12px",
                borderRadius: "4px",
                cursor: "pointer",
                fontSize: "12px",
                fontWeight: "500",
                boxShadow: "0 1px 3px rgba(0, 0, 0, 0.3)",
                transition: "all 0.2s ease",
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.background = "linear-gradient(135deg, #7a8eee, #8659b5)";
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.background = "linear-gradient(135deg, #667eea, #764ba2)";
              }}
            >
              Use Item
            </button>
          </div>
          </div>
        </>
      )}
      <div
        className="game-inventory-panel"
        style={{
        width: layout.panelWidth,
        minWidth: layout.panelWidth,
        maxHeight: layout.panelMaxHeight,
        color: "#fff",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        margin: "0 auto",
        zIndex: 1000
      }}
    >
      <div className="inventory-header">
        <div className="inventory-title-group">
          <div className="inventory-accent-bar" />
          <h4 className="inventory-title">Inventory</h4>
        </div>
        {typeof onClose === "function" && (
          <button
            onClick={(e) => {
              e.stopPropagation();
              onClose();
            }}
            className="inventory-close-btn"
            aria-label="Close inventory"
            title="Close"
          >
            ✕
          </button>
        )}
      </div>
      <div className="inventory-section-header">
        <div className="section-accent-bar items" />
        <h4 className="section-title">Items</h4>
      </div>
      <div 
        className="inventory-grid"
        style={{
          display: "grid",
          gridTemplateColumns: `repeat(${layout.cols}, ${layout.tile}px)`,
          gap: layout.gap,
          maxHeight: layout.itemsMaxHeight,
          justifyContent: layout.gridJustify,
          alignContent: "start",
        }}
      >
        {orderedItems.map(renderItem)}
      </div>

      <div className="inventory-section-header">
        <div className="section-accent-bar minerals" />
        <h4 className="section-title">Minerals</h4>
      </div>
      <div 
        className="inventory-grid"
        style={{
          display: "grid",
          gridTemplateColumns: `repeat(${layout.cols}, ${layout.tile}px)`,
          gap: layout.gap,
          maxHeight: layout.gemsMaxHeight,
          justifyContent: layout.gridJustify,
          alignContent: "start",
        }}
      >
        {Object.entries(gems).map(renderGem)}
      </div>
    </div>
    </>
  );
}
